"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTypeRamp = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _typography = require("../../typography");
var _paginationTheme = require("../paginationTheme");
function shouldForwardProp(propName) {
  switch (propName) {
    case "themeMode":
      return false;
  }
  return true;
}
const StyledTypeRamp = (0, _styled.default)(_typography.TypeRampV2, {
  shouldForwardProp
})(_ref => {
  let {
    themeMode
  } = _ref;
  return `
    padding: ${_paginationTheme.paginationTheme.text.padding(themeMode)};
`;
});
exports.StyledTypeRamp = StyledTypeRamp;
//# sourceMappingURL=StyledTypeRamp.js.map